import React, { useEffect } from 'react';
import { KFLButton, KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import DialogHeader from '../../shared/dialog/dialogHeader';
import Translate from '../../shared/localization/localize';
import DialogSection from '../../shared/dialog/dialogSection';
import {
  TransferDialogs,
  TransferStatus,
} from '../../../modules/dialogs/transfer';
import TransferSummary, {
  roundFailIcon,
  roundOkIcon,
} from './transferSummary';
import Scrim from '../../shared/scrim';
import * as m from '../../../modules/dialogs/transfer/messages';
import { useTxSend } from '../../../modules/dialogs/transfer/useTxSend';
import DialogFooter from '../../shared/dialog/dialogFooter';
import useLocale from '../../../hooks/useLocale';
import SandwichBox from '../../shared/sandwichBox';

const TxDialogSendFinal: React.FC = () => {
  const { translate } = useLocale();
  const {
    tx,
    sendTxDevices,
    sendTxDevicesStatus,
    closePanel,
    changeScreen,
  } = useTxSend();

  useEffect(() => {
    tx.status === TransferStatus.CONFIRMED && sendTxDevices();
  }, []);

  const isCompleted = tx.status === TransferStatus.COMPLETED;
  const isFetching = sendTxDevicesStatus.isFetching;
  const summaryLogo = sendTxDevicesStatus.errorMsg
    ? roundFailIcon
    : roundOkIcon;
  const summaryHeader = sendTxDevicesStatus.errorMsg
    ? m.msgTransferingError
    : m.msgSendTransferSucceed;

  const content = (
    <>
      <DialogSection isMain scrollable>
        <Scrim
          isActive={isFetching}
          label={translate(m.msgTransfering)}
          iconSize={16}
          fullHeight
        >
          {isFetching ? (
            <></>
          ) : (
            <SandwichBox
              bottom_bun={
                <SandwichBox>
                  {!isCompleted && (
                    <div className="tx_failed_box">
                      <KFLButton
                        id="dg-tx-send-bt-refinish"
                        key="dg-tx-send-bt-refinish"
                        onClick={() => sendTxDevices()}
                      >
                        {translate(m.msgRetryBtn)}
                      </KFLButton>
                    </div>
                  )}
                </SandwichBox>
              }
            >
              <TransferSummary
                transfer={tx}
                title={summaryHeader}
                icon={summaryLogo}
              ></TransferSummary>
            </SandwichBox>
          )}
        </Scrim>
      </DialogSection>
    </>
  );

  const activitiesBtn = (
    <KFLButton
      id="dg-tx-send-bt-activities"
      variant="secondary"
      onClick={() => changeScreen(TransferDialogs.ACTIVITIES_CLOSED)}
    >
      {translate(m.msgActivitiesBtn)}
    </KFLButton>
  );

  return (
    <KFLDialog
      header={
        <DialogHeader
          title={<Translate message={m.msgHeaderSend} />}
          fnCloseDialog={closePanel}
          fnBackDialog={() => changeScreen(TransferDialogs.SEND)}
        />
      }
      sections={[content]}
      footer={
        <DialogFooter
          leftContent={isCompleted ? activitiesBtn : ''}
          buttons={[]}
          hideCancelBtn
          fnCloseDialog={closePanel}
        />
      }
    />
  );
};

export default TxDialogSendFinal;
